<template>
  <div class="home-page">
    <section class="hero-section">
      <v-container>
        <v-row align="center">
          <v-col cols="12" lg="5" class="hero-copy">
            <span class="eyebrow">DISEÑAMOS • SUBLIMAMOS • ESTAMPAMOS</span>
            <h1>Convertimos tus ideas en productos <em>únicos</em> que cuentan historias.</h1>
            <p>
              Personaliza tazas, franelas, termos, gorras, llaveros, mouse pads y más
              con fotos, nombres, logos o diseños especiales.
            </p>

            <div class="hero-actions">
              <v-btn large color="primary" class="main-button" @click="goToCatalog">
                Ver catálogo <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn large outlined color="primary" @click="openWhatsApp('Hola Aguila Print, quiero cotizar una idea personalizada')">
                <v-icon left>mdi-whatsapp</v-icon> Cotizar una idea
              </v-btn>
            </div>

            <div class="hero-trust">
              <span><v-icon small color="success">mdi-check-circle</v-icon> Desde una unidad</span>
              <span><v-icon small color="success">mdi-check-circle</v-icon> Diseño previo</span>
              <span><v-icon small color="success">mdi-check-circle</v-icon> Envíos nacionales</span>
            </div>
          </v-col>

          <v-col cols="12" lg="7">
            <div class="hero-collage">
              <div class="collage-product shirt">
                <v-img :src="images.shirt" contain />
              </div>
              <div class="collage-product mug">
                <v-img :src="images.mug" contain />
              </div>
              <div class="collage-product bottle">
                <v-img :src="images.bottle" contain />
              </div>
              <div class="collage-product cap">
                <v-img :src="images.cap" contain />
              </div>
              <div class="collage-product keychain">
                <v-img :src="images.keychain" contain />
              </div>
              <div class="custom-badge">
                <v-icon color="primary">mdi-palette-outline</v-icon>
                <div><strong>100% personalizable</strong><small>Tu foto, nombre o diseño</small></div>
              </div>
              <div class="collage-dots"><i></i><i></i><i></i></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="benefits-strip">
      <v-container>
        <v-row>
          <v-col v-for="item in benefits" :key="item.title" cols="12" sm="6" lg="3">
            <div class="benefit-item">
              <v-icon color="primary" size="31">{{ item.icon }}</v-icon>
              <div><strong>{{ item.title }}</strong><span>{{ item.text }}</span></div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="section white-section offers-section">
      <v-container>
        <div class="section-title compact"><span>🔥 PROMOCIONES</span><h2>Ofertas de la semana</h2></div>
        <v-row>
          <v-col v-for="offer in offers" :key="offer.title" cols="12" md="4">
            <v-card flat class="offer-card" @click="openWhatsApp(offer.message)">
              <v-img :src="offer.image" contain width="145" height="135" class="offer-image" />
              <div class="offer-content">
                <span class="offer-tag">{{ offer.tag }}</span>
                <h3>{{ offer.title }}</h3>
                <p>{{ offer.description }}</p>
                <strong>{{ offer.price }}</strong>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="section soft-section">
      <v-container>
        <div class="section-title"><span>⭐ LOS FAVORITOS</span><h2>Productos más vendidos</h2><p>Ideas que funcionan para regalar, celebrar o impulsar tu marca.</p></div>
        <v-row>
          <v-col v-for="product in bestSellers" :key="product.name" cols="6" sm="4" lg="2">
            <v-card flat class="product-mini-card" @click="goToCatalog">
              <v-img :src="product.image" contain height="175" class="product-mini-image" />
              <div class="product-mini-body">
                <h3>{{ product.name }}</h3>
                <div class="stars"><v-icon v-for="n in 5" :key="n" x-small color="amber darken-1">mdi-star</v-icon><small>({{ product.reviews }})</small></div>
                <span>Desde {{ product.price }}</span>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="center-action"><v-btn outlined color="primary" large @click="goToCatalog">Ver todos los productos <v-icon right>mdi-arrow-right</v-icon></v-btn></div>
      </v-container>
    </section>

    <section class="section white-section occasions-section">
      <v-container>
        <div class="section-title compact"><span>🎁 PARA CADA MOMENTO</span><h2>Encuentra el regalo perfecto</h2></div>
        <div class="occasion-grid">
          <button v-for="occasion in occasions" :key="occasion.title" class="occasion-card" @click="openWhatsApp('Hola Aguila Print, busco un regalo ' + occasion.title.toLowerCase())">
            <span>{{ occasion.emoji }}</span><strong>{{ occasion.title }}</strong>
          </button>
        </div>
      </v-container>
    </section>

    <section class="section process-section">
      <v-container>
        <div class="section-title compact light"><span>ASÍ DE FÁCIL</span><h2>Personaliza sin complicaciones</h2></div>
        <div class="process-grid">
          <div v-for="(step,index) in steps" :key="step.title" class="process-card">
            <span class="step-number">{{ index + 1 }}</span>
            <v-icon color="primary" size="34">{{ step.icon }}</v-icon>
            <h3>{{ step.title }}</h3><p>{{ step.text }}</p>
            <v-icon v-if="index < steps.length - 1" class="process-arrow" color="primary">mdi-arrow-right</v-icon>
          </div>
        </div>
      </v-container>
    </section>

    <section class="section white-section social-proof-section">
      <v-container>
        <v-row>
          <v-col cols="12" lg="6">
            <div class="section-title left"><span>HECHO CON CARIÑO</span><h2>Nuestros trabajos</h2><p>Algunas ideas que podemos crear o adaptar a tu estilo.</p></div>
            <div class="gallery-grid">
              <div v-for="(photo,index) in gallery" :key="index"><v-img :src="photo" aspect-ratio="1" cover /></div>
            </div>
            <v-btn outlined color="primary" class="mt-5" @click="openInstagram"><v-icon left>mdi-instagram</v-icon> Ver más trabajos</v-btn>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="section-title left"><span>CLIENTES FELICES</span><h2>Lo que dicen de nosotros</h2><p>La confianza se gana producto a producto.</p></div>
            <v-row>
              <v-col v-for="review in reviews" :key="review.name" cols="12" md="4" lg="12" xl="4">
                <v-card flat class="review-card">
                  <div class="stars mb-3"><v-icon v-for="n in 5" :key="n" small color="amber darken-1">mdi-star</v-icon></div>
                  <p>“{{ review.text }}”</p>
                  <div class="review-user"><v-avatar size="38" color="purple lighten-5"><v-icon color="primary">mdi-account</v-icon></v-avatar><div><strong>{{ review.name }}</strong><small>{{ review.city }}</small></div></div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="stats-section">
      <v-container>
        <div class="stats-grid">
          <div v-for="stat in stats" :key="stat.label"><v-icon size="38">{{ stat.icon }}</v-icon><strong>{{ stat.value }}</strong><span>{{ stat.label }}</span></div>
        </div>
      </v-container>
    </section>

    <section id="insumos" class="section supplies-section">
      <v-container>
        <div class="section-title"><span>PRÓXIMAMENTE</span><h2>Insumos para sublimación</h2><p>Una futura sección para emprendedores y talleres creativos.</p></div>
        <v-row>
          <v-col v-for="supply in supplies" :key="supply.name" cols="6" sm="4" lg="2">
            <v-card flat class="supply-card">
              <v-img :src="supply.image" contain height="130" />
              <h3>{{ supply.name }}</h3><span>Próximamente</span>
            </v-card>
          </v-col>
        </v-row>
        <div class="supplies-cta">
          <div><v-icon color="white" size="42">mdi-package-variant-closed</v-icon><div><strong>¿Vendes o produces sublimación?</strong><span>Avísanos qué insumos te gustaría encontrar.</span></div></div>
          <v-btn color="white" class="primary--text" large @click="openWhatsApp('Hola Aguila Print, me interesa la futura sección de insumos para sublimación')">Quiero recibir información</v-btn>
        </div>
      </v-container>
    </section>

    <section class="section faq-section">
      <v-container>
        <v-row align="start">
          <v-col cols="12" md="5"><div class="section-title left"><span>DUDAS COMUNES</span><h2>Preguntas frecuentes</h2><p>La información que necesitas antes de realizar tu pedido.</p></div></v-col>
          <v-col cols="12" md="7"><v-expansion-panels flat accordion><v-expansion-panel v-for="faq in faqs" :key="faq.question"><v-expansion-panel-header>{{ faq.question }}</v-expansion-panel-header><v-expansion-panel-content>{{ faq.answer }}</v-expansion-panel-content></v-expansion-panel></v-expansion-panels></v-col>
        </v-row>
      </v-container>
    </section>

    <section class="cta-section">
      <v-container>
        <div class="cta-box">
          <div><span>¿TIENES UNA IDEA?</span><h2>Vamos a convertirla en algo especial.</h2><p>Cuéntanos qué quieres crear y te ayudamos con el producto, diseño y acabado.</p></div>
          <v-btn x-large color="white" class="primary--text" @click="openWhatsApp('Hola Aguila Print, tengo una idea y quiero cotizarla')"><v-icon left>mdi-whatsapp</v-icon> Hablar con Aguila Print</v-btn>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "AguilaPrintHome",
  data() {
    const mug = require("@/assets/taza_mock.png");
    const shirt = require("@/assets/poleraparapersonalizada.png");
    const bottle = require("@/assets/termo_perso2.png");
    const bottle2 = require("@/assets/termo_perso.png");
    const cap = require("@/assets/gorra1.png");
    const keychain = require("@/assets/llavero1.png");
    const keychain2 = require("@/assets/llavero2.png");
    const mouse = require("@/assets/mouse_spiderman.png");
    return {
      images: { mug, shirt, bottle, bottle2, cap, keychain, keychain2, mouse },
      benefits: [
        { icon: "mdi-palette-outline", title: "Diseños personalizados", text: "Fotos, nombres, frases y logos" },
        { icon: "mdi-eye-check-outline", title: "Vista previa", text: "Apruebas antes de producir" },
        { icon: "mdi-package-variant", title: "Desde una unidad", text: "Ideal para regalos y negocios" },
        { icon: "mdi-truck-fast-outline", title: "Envíos nacionales", text: "Recibe tu pedido donde estés" }
      ],
      offers: [
        { title: "Taza + caja premium", description: "Un regalo listo para entregar.", price: "Consultar promoción", tag: "PACK REGALO", image: mug, message: "Hola Aguila Print, quiero consultar la promoción de taza con caja" },
        { title: "Franelas personalizadas", description: "Ideal para parejas, equipos y eventos.", price: "Precio especial por cantidad", tag: "DESDE 2 UNIDADES", image: shirt, message: "Hola Aguila Print, quiero cotizar franelas personalizadas" },
        { title: "Termos personalizados", description: "Diseño resistente para uso diario.", price: "Descuento disponible", tag: "PROMOCIÓN", image: bottle2, message: "Hola Aguila Print, quiero cotizar termos personalizados" }
      ],
      bestSellers: [
        { name: "Taza personalizada", image: mug, reviews: 128, price: "$6.50" },
        { name: "Franela personalizada", image: shirt, reviews: 96, price: "$8.50" },
        { name: "Termo personalizado", image: bottle2, reviews: 74, price: "$12.00" },
        { name: "Gorra personalizada", image: cap, reviews: 62, price: "$7.00" },
        { name: "Llavero personalizado", image: keychain, reviews: 58, price: "$2.00" },
        { name: "Mouse pad", image: mouse, reviews: 48, price: "$2.00" }
      ],
      occasions: [
        { emoji: "❤️", title: "Para parejas" }, { emoji: "👨", title: "Para papá" },
        { emoji: "👩", title: "Para mamá" }, { emoji: "🎂", title: "Cumpleaños" },
        { emoji: "👶", title: "Bebés" }, { emoji: "🐶", title: "Mascotas" },
        { emoji: "🎓", title: "Graduaciones" }, { emoji: "🎄", title: "Navidad" },
        { emoji: "🎁", title: "Más ocasiones" }
      ],
      steps: [
        { icon: "mdi-shopping-outline", title: "Elige tu producto", text: "Escoge lo que deseas personalizar." },
        { icon: "mdi-cloud-upload-outline", title: "Sube tu idea", text: "Envíanos la foto, frase, nombre o logo." },
        { icon: "mdi-eye-check-outline", title: "Vista previa", text: "Te mostramos cómo quedará para aprobarlo." },
        { icon: "mdi-printer-outline", title: "Fabricamos", text: "Producimos con cuidado y buenos acabados." },
        { icon: "mdi-truck-delivery-outline", title: "Recibe tu pedido", text: "Coordinamos la entrega de tu producto." }
      ],
      gallery: [mug, shirt, bottle, keychain, cap, mouse, keychain2, bottle2, mug, shirt, bottle, keychain],
      reviews: [
        { name: "María Fernanda", city: "Maracaibo", text: "Excelente calidad y atención. La taza quedó mejor de lo que esperaba." },
        { name: "Luis G.", city: "Maracaibo", text: "La franela quedó increíble y el proceso fue rápido y claro." },
        { name: "Andreina P.", city: "Venezuela", text: "Me ayudaron con el diseño y el resultado fue perfecto para regalar." }
      ],
      stats: [
        { icon: "mdi-cart-check", value: "+500", label: "Pedidos realizados" },
        { icon: "mdi-account-group", value: "+300", label: "Clientes satisfechos" },
        { icon: "mdi-tag-multiple", value: "+20", label: "Productos disponibles" },
        { icon: "mdi-palette", value: "100%", label: "Diseños personalizados" },
        { icon: "mdi-star", value: "5.0", label: "Experiencia cercana" }
      ],
      supplies: [
        { name: "Tazas en blanco", image: mug }, { name: "Termos", image: bottle2 },
        { name: "Franelas blancas", image: shirt }, { name: "Vinilo textil", image: shirt },
        { name: "Papel de sublimación", image: mug }, { name: "Tintas y accesorios", image: bottle }
      ],
      faqs: [
        { question: "¿Puedo enviar mi propia foto o diseño?", answer: "Sí. Puedes enviarlo por WhatsApp y revisaremos la calidad antes de producir." },
        { question: "¿Me muestran cómo quedará antes de imprimir?", answer: "Sí. Para los diseños personalizados enviamos una vista previa para aprobación." },
        { question: "¿Trabajan desde una sola unidad?", answer: "Sí. También podemos preparar precios especiales para cantidades mayores." },
        { question: "¿Realizan envíos?", answer: "Sí. Coordinamos entregas locales y envíos nacionales según el destino." },
        { question: "¿Cuánto tarda un pedido?", answer: "Depende del producto y la cantidad. Te indicamos el tiempo estimado al confirmar el diseño." }
      ]
    };
  },
  mounted() {
    if (this.$route.query.section === "insumos") {
      this.$nextTick(() => {
        const element = document.getElementById("insumos");
        if (element) element.scrollIntoView({ behavior: "smooth" });
      });
    }
  },
  methods: {
    goToCatalog() { this.$router.push("/product"); },
    openWhatsApp(message) {
      window.open(`https://wa.me/584146058924?text=${encodeURIComponent(message)}`, "_blank");
    },
    openInstagram() { window.open("https://www.instagram.com/", "_blank"); }
  }
};
</script>

<style scoped>
.home-page{overflow:hidden;color:#261e2b;background:#fff}.section{padding:76px 0}.white-section{background:#fff}.soft-section{background:#faf8fc}.eyebrow,.section-title>span,.cta-box>div>span{color:#7b16bd;font-size:12px;font-weight:900;letter-spacing:.14em}.section-title{max-width:760px;margin:0 auto 36px;text-align:center}.section-title.compact{margin-bottom:28px}.section-title.left{text-align:left;margin:0 0 28px}.section-title h2{margin:8px 0 10px;font-size:clamp(29px,3.8vw,44px);line-height:1.12;letter-spacing:-.025em}.section-title p{color:#756d79;font-size:16px;line-height:1.7}.hero-section{padding:65px 0 55px;background:radial-gradient(circle at 82% 20%,#e8d7ff 0,transparent 35%),linear-gradient(135deg,#fff 0%,#f7f0ff 100%)}.hero-copy h1{max-width:650px;margin:15px 0 20px;font-size:clamp(39px,5.1vw,68px);line-height:1.02;letter-spacing:-.052em}.hero-copy h1 em{color:#7417b1;font-style:normal}.hero-copy p{max-width:620px;color:#675f6c;font-size:17px;line-height:1.7}.hero-actions{display:flex;flex-wrap:wrap;gap:13px;margin-top:27px}.main-button{box-shadow:0 12px 25px rgba(105,0,170,.22)!important}.hero-trust{display:flex;flex-wrap:wrap;gap:17px;margin-top:24px;color:#625a65;font-size:12px}.hero-collage{position:relative;min-height:500px;border-radius:34px;background:rgba(255,255,255,.72);box-shadow:0 28px 75px rgba(72,25,105,.14);overflow:hidden}.collage-product{position:absolute}.collage-product .v-image{width:100%;height:100%}.shirt{left:5%;top:7%;width:48%;height:79%}.mug{left:43%;top:10%;width:31%;height:47%}.bottle{right:2%;top:7%;width:23%;height:78%}.cap{left:38%;bottom:3%;width:34%;height:35%}.keychain{left:8%;bottom:4%;width:20%;height:25%}.custom-badge{position:absolute;right:4%;bottom:6%;display:flex;align-items:center;gap:10px;padding:13px 17px;border-radius:16px;background:#fff;box-shadow:0 13px 30px rgba(55,23,79,.14)}.custom-badge strong,.custom-badge small{display:block}.custom-badge small{color:#777;font-size:11px}.collage-dots{position:absolute;bottom:15px;left:50%;display:flex;gap:6px;transform:translateX(-50%)}.collage-dots i{width:7px;height:7px;border-radius:50%;background:#d2bee0}.collage-dots i:first-child{background:#7417b1}.benefits-strip{border-top:1px solid #eee;border-bottom:1px solid #eee;background:#fff}.benefit-item{display:flex;align-items:center;gap:13px;padding:16px 0}.benefit-item strong,.benefit-item span{display:block}.benefit-item span{margin-top:3px;color:#777;font-size:12px}.offer-card{display:flex;align-items:center;height:100%;padding:14px;border:1px solid #eee!important;border-radius:18px!important;cursor:pointer;transition:.25s}.offer-card:hover{transform:translateY(-5px);box-shadow:0 17px 35px rgba(60,24,82,.1)!important}.offer-image{flex:0 0 145px;background:#faf8fb;border-radius:14px}.offer-content{padding:8px 10px}.offer-tag{display:inline-block;padding:4px 8px;border-radius:6px;background:#f1e4fa;color:#6c179f;font-size:10px;font-weight:800}.offer-content h3{margin:8px 0 4px;font-size:18px}.offer-content p{margin:0 0 5px;color:#777;font-size:13px}.offer-content strong{color:#6c179f}.product-mini-card{height:100%;overflow:hidden;border:1px solid #ece8ef!important;border-radius:17px!important;cursor:pointer;transition:.24s}.product-mini-card:hover{transform:translateY(-6px);box-shadow:0 16px 35px rgba(47,17,68,.11)!important}.product-mini-image{background:#fff}.product-mini-body{padding:13px}.product-mini-body h3{min-height:38px;font-size:14px;line-height:1.35}.stars{display:flex;align-items:center}.stars small{margin-left:3px;color:#888}.product-mini-body>span{display:block;margin-top:7px;color:#5d5362;font-size:12px}.center-action{text-align:center;margin-top:30px}.occasion-grid{display:grid;grid-template-columns:repeat(9,1fr);gap:10px}.occasion-card{padding:17px 8px;border:1px solid #eee;border-radius:14px;background:#fff;box-shadow:0 5px 14px rgba(34,17,46,.05);transition:.2s}.occasion-card:hover{transform:translateY(-4px);border-color:#c99be5}.occasion-card span,.occasion-card strong{display:block}.occasion-card span{font-size:31px}.occasion-card strong{margin-top:7px;font-size:12px}.process-section{background:#fbf8fd}.process-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:16px}.process-card{position:relative;padding:22px 18px;border:1px solid #ebe3f0;border-radius:17px;background:#fff}.step-number{position:absolute;top:-12px;left:13px;width:28px;height:28px;border-radius:50%;background:#7215ad;color:#fff;text-align:center;line-height:28px;font-weight:800}.process-card h3{margin:13px 0 5px;font-size:15px}.process-card p{margin:0;color:#777;font-size:12px;line-height:1.55}.process-arrow{position:absolute;right:-28px;top:44%;z-index:2}.gallery-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:7px;overflow:hidden;border-radius:17px}.gallery-grid>div{overflow:hidden;background:#f6f1f8}.review-card{height:100%;padding:20px;border:1px solid #eee!important;border-radius:16px!important}.review-card>p{min-height:68px;color:#5f5862;font-size:13px;line-height:1.7}.review-user{display:flex;align-items:center;gap:10px}.review-user strong,.review-user small{display:block}.review-user small{color:#888}.stats-section{padding:20px 0;background:linear-gradient(135deg,#4f0879,#7c1bbb);color:#fff}.stats-grid{display:grid;grid-template-columns:repeat(5,1fr)}.stats-grid>div{text-align:center;padding:20px;border-right:1px solid rgba(255,255,255,.16)}.stats-grid>div:last-child{border:0}.stats-grid .v-icon{color:#d9a9f3}.stats-grid strong,.stats-grid span{display:block}.stats-grid strong{margin-top:7px;font-size:25px}.stats-grid span{color:rgba(255,255,255,.78);font-size:12px}.supplies-section{background:#fff}.supply-card{height:100%;padding:13px;text-align:center;border:1px solid #eee!important;border-radius:16px!important}.supply-card h3{font-size:14px}.supply-card span{color:#8c4bb5;font-size:11px}.supplies-cta{display:flex;align-items:center;justify-content:space-between;gap:25px;margin-top:30px;padding:26px 30px;border-radius:20px;background:linear-gradient(135deg,#55117e,#8b24bd);color:#fff}.supplies-cta>div{display:flex;align-items:center;gap:15px}.supplies-cta strong,.supplies-cta span{display:block}.supplies-cta span{color:rgba(255,255,255,.72)}.faq-section{background:#faf8fc}.v-expansion-panel{margin-bottom:8px;border:1px solid #eee!important;border-radius:12px!important}.cta-section{padding:65px 0;background:#fff}.cta-box{display:flex;align-items:center;justify-content:space-between;gap:28px;padding:40px 46px;border-radius:27px;background:linear-gradient(135deg,#53107e,#8d27c2);color:#fff}.cta-box h2{margin:7px 0;font-size:clamp(29px,3.5vw,44px)}.cta-box p{margin:0;color:rgba(255,255,255,.75)}
@media(max-width:1264px){.occasion-grid{grid-template-columns:repeat(5,1fr)}.process-grid{grid-template-columns:repeat(3,1fr)}.process-arrow{display:none}.stats-grid{grid-template-columns:repeat(3,1fr)}.stats-grid>div{border:0}.hero-collage{min-height:440px}}
@media(max-width:960px){.hero-section{padding-top:38px}.hero-collage{min-height:430px;margin-top:25px}.process-grid{grid-template-columns:repeat(2,1fr)}.cta-box,.supplies-cta{align-items:flex-start;flex-direction:column}.stats-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.section{padding:55px 0}.hero-copy h1{font-size:40px}.hero-copy p{font-size:15px}.hero-actions .v-btn{width:100%}.hero-collage{min-height:330px;border-radius:22px}.shirt{left:0;width:50%;height:72%}.mug{left:41%;width:34%}.bottle{right:-2%;width:27%}.cap{left:34%;width:38%}.keychain{width:23%}.custom-badge{right:7px;bottom:7px;padding:9px 10px}.custom-badge small{display:none}.offer-card{flex-direction:column;align-items:flex-start}.offer-image{width:100%!important;max-width:none!important;flex:auto}.occasion-grid{grid-template-columns:repeat(3,1fr)}.process-grid{grid-template-columns:1fr}.gallery-grid{grid-template-columns:repeat(3,1fr)}.stats-grid{grid-template-columns:1fr 1fr}.stats-grid>div{padding:14px}.supplies-cta,.cta-box{padding:28px 22px}.cta-box .v-btn,.supplies-cta .v-btn{width:100%}.product-mini-image{height:135px!important}.product-mini-body{padding:10px}}
</style>
